// src/constants/projectRoles.js
//
// Single source of truth for project-role values + display labels.
// Values must match aiprime.project_role enum exactly.
//
// Org roles live separately in orgRoles.js — different axis.
// License tiers live in licenseTiers.js — different axis again.
// All three axes compose; min-of-axes wins per REQ-046.

export const PROJECT_ROLE_OPTIONS = [
  { value: "owner",  label: "Project Owner"  },
  { value: "editor", label: "Project Editor" },
  { value: "viewer", label: "Project Viewer" },
];

export const PROJECT_ROLE_LABEL = Object.fromEntries(
  PROJECT_ROLE_OPTIONS.map(r => [r.value, r.label])
);

export const DEFAULT_PROJECT_INVITE_ROLE = "viewer";

// Backwards-compat alias for callers using the old { id, label } shape.
// New code should import PROJECT_ROLE_OPTIONS directly. Remove this
// once all callers have migrated.
export const PROJECT_ROLES = PROJECT_ROLE_OPTIONS.map(r => ({
  id: r.value,
  label: r.label,
}));